export default "__VITE_ASSET__61624dfa__$_?nuxt_component=async__"